import React from "react";
import ReactApexChart from "react-apexcharts";

const Barchart = () => {
  const series = [
    {
      name: "Net Profit",
      data: [1, 2, 1, 3, 1, 2],
    },
  ];

  const options = {
    chart: {
      type: "bar",
      height: 350,
      toolbar: {
        show: false,
      },
      fontFamily: "Pio Medium",
    },
    title: {
      text: "Project's Summary",
      align: "left",
      style: {
        fontSize: "18px",
        fontWeight: "500",
        color: "#000000",
      },
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: "55%",
        endingShape: "rounded",
        borderRadius: 10,
      },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      show: true,
      width: 2,
      colors: ["transparent"],
    },
    xaxis: {
      categories: ["Feb", "Mar", "Apr", "May", "Jun", "Jul"],
    },
    yaxis: {
      min: 0,
      max: 4, // Optional, just to control the upper range
      tickAmount: 4, // Controls how many steps (0, 1, 2, 3, 4)
      labels: {
        style: {
          fontSize: "12px",
        },
      },
    },
    fill: {
      opacity: 1,
      colors: "#22c55e",
    },
    tooltip: {
      y: {
        formatter: function (val) {
          return "OMR " + val + " ";
        },
      },
    },
    grid: {
      yaxis: {
        lines: {
          show: false,
        },
      },
    },
  };

  return (
    <div>
      <div id="chart">
        <ReactApexChart
          options={options}
          series={series}
          type="bar"
          height={350}
        />
      </div>
      <div id="html-dist"></div>
    </div>
  );
};

export default Barchart;
